import { render, staticRenderFns } from "./ControlloQualita.vue?vue&type=template&id=56fa4278&scoped=true&"
import script from "./ControlloQualita.vue?vue&type=script&lang=js&"
export * from "./ControlloQualita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa4278",
  null
  
)

export default component.exports